module.exports = __webpack_public_path__ + "static/img/26.73b50da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene/26.jpg
// module id = b84h
// module chunks = 3